import * as React from 'react';
import { Typography, Box, Container, TextField, CssBaseline, Button, Avatar, Select, MenuItem, InputLabel, FormHelperText, FormControl, CircularProgress, Chip, Badge, BadgeMark } from '@mui/material';
import { connect } from "react-redux";
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import Logo from "../../app/components/chainz-logo.png";
import { centered_flex_box, main_button } from '../../app/components/Styles';
import { AccountBalance, AdminPanelSettings, BadgeOutlined, HeadsetMic, MonetizationOn, VerifiedUser } from '@mui/icons-material';
import ImageComponent from '../../app/components/ImageComponent';
import { posHomeUrl, posLoginUrl } from '../../constants/posApp';

export const AdminHome = ({ token }) => {

    const role = token?.split(" ")[0]
    const navigate = useNavigate()
    const eventId = useParams().id

    if(role === "InventoryAdmin"){
        return Navigate({to: "/ims/admin"})
    } else if(role === "InventoryEmployee") {
        return Navigate({to: "/ims/employee"})
    } else if(role === "Finance") {
        return Navigate({to: "/warehousing/finance"})
    } else if(role === "WarehouseStaff") {
        return Navigate({to: "/ims/warehouse-staff"})
    } else if(role === "Cashier") {
        window.location.assign(posHomeUrl());
        return null;
    }

    return (
        <Container component="main">
            <Box sx={{ ...centered_flex_box, flexDirection: "column" }}>
                <ImageComponent preview={false} src={Logo} width="160px" style={{ borderRadius: 24, marginBottom: 16 }} />
                {<Button sx={{ ...main_button, m: 1 }} onClick={() => navigate("/login")}><AdminPanelSettings /><Typography marginX={2}>Login Admin</Typography></Button>}
                {<Button sx={{ ...main_button, m: 1 }} onClick={() => navigate("/ims/warehouse-staff/login")}><MonetizationOn /><Typography marginX={2}>Login Warehouse Staff</Typography></Button>}
                {<Button sx={{ ...main_button, m: 1 }} onClick={() => navigate("/warehousing/finance/login")}><MonetizationOn /><Typography marginX={2}>Login Finance</Typography></Button>}
                {<Button sx={{ ...main_button, m: 1 }} onClick={() => navigate("/ims/employee/login")}><BadgeOutlined /><Typography marginX={2}>تسجيل دخول موظف</Typography></Button>}
                {<Button sx={{ ...main_button, m: 1 }} href={posLoginUrl()}><VerifiedUser /><Typography marginX={2}>Login Cashier (POS)</Typography></Button>}
                {<Button sx={{ ...main_button, m: 1 }} href="https://help.chainzsolutions.com" target="_blank" rel="noopener noreferrer"><HeadsetMic /><Typography marginX={2}>Login Helpdesk</Typography></Button>}
                {<Button sx={{ ...main_button, m: 1 }} href="https://chainz-system.vercel.app/login" target="_blank" rel="noopener noreferrer"><AccountBalance /><Typography marginX={2}>Login Internal System (Reconciliation)</Typography></Button>}
            </Box>
        </Container>
    );
}

const mapStateToProps = (state) => ({
    token: state?.auth?.token
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AdminHome);